<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-22 20:52:35
 * @LastEditTime: 2022-02-25 22:45:58
 * @LastEditors: chenguobiao
-->
<template>
  <div class="personal--activity page-normal">
    <common-header selected="user" />
    <div class="page-normal__content">
      <div class="copy--tips">
        <div class="copy">以下活动为官方已发布国际象棋考级赛事活动，请选手根据各项活动时间合理选择报名，以参加国际象棋定级考试！</div>
        <common-back :backHome="false" />
      </div>
      <div class="activity--list">
        <template v-if="activityList && activityList.length > 0">
          <div class="activity--item" v-for="activity in activityList" :key="activity.uid">
            <div class="col">
              <p>{{activity.activityName}}</p>
              <p>考试时间：{{activity.activityStartTime}}--{{activity.activityEndTime}}</p>
              <p>{{activity.introduction}}</p>
            </div>
            <div class="col">
              <p>报名人数：<span class="molecular">{{activity.enrollNum}}</span>/<span class="denominator">{{activity.limitNum}}</span> 人</p>
              <progress-component :molecular="activity.enrollNum" :denominator="activity.limitNum"/>
            </div>
            <div class="col">
              <p @click="signUp(activity.uid)">报名</p>
              <p>{{activity.startEnrollTime}}~{{activity.deadlineEnrollTime}}</p>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="activity--list__nodata">
            <img src="@/render/assets/images/home/nodata.png">
            <div class="activity--list__nodata__text">暂无活动数据</div>
          </div>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import { personalAPI } from '@/apis'
import CommonHeader from '@/render/components/common/header'
import CommonBack from '@/render/components/common/back'
import Progress from "./component/progress"

export default {
  data() {
    return {
      activityList: [],
      productUid: '',
      checkType: 0
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(query) {
        const {productUid, checkType} = query
        if (productUid && checkType) {
          this.productUid = productUid
          this.checkType = checkType
          this.getAvailableActivityList()
        } else {
          this.$router.replace('/home')
        }
      }
    }
  },
  components: {
    CommonHeader,
    CommonBack,
    ProgressComponent: Progress
  },
  methods: {
    async getAvailableActivityList() {
      const { data } = await personalAPI.postGetAvailableActivityList()
      this.activityList = data
    },
    async signUp(uid) {
      const { checkType, productUid } = this
      await personalAPI.postJudgeEnrollActivity({
        uid,
        productUid
      })
      this.$router.push(`/personal-agreement?checkType=${checkType}&productUid=${productUid}&uid=${uid}`)
      
    }
  }
}
</script>

<style lang="scss">
  .personal--activity {
    .copy--tips {
      position: relative;
      margin: val(24) auto val(14);
      width: val(1200);
      height: val(36);
      line-height: val(36);
      background: #F5F4F4;
      box-shadow: 0px val(3) val(6) rgba(0, 0, 0, 0.16);
      border-radius: val(4);
      .copy {
        font-size: val(16);
        color: #9F9D96;
        padding-left: val(36);
      }
    }
    .activity{
      &--list {
        width: val(1218);
        height: calc(100vh - 2rem);
        margin: 0 auto;
        overflow: auto;
        display: flex;
        flex-direction: column;
        .activity--item {
          padding: val(40) val(30) val(45) val(35);
          width: 100%;
          height: val(198);
          background: url(../../../assets/images/personal/activity_bg.png) left top no-repeat;
          background-size: 100%;
          display: flex;
          box-sizing: border-box;
          .col {
            &:first-of-type {
              width: val(417);
              margin-right: val(40);
              p {
                &:first-of-type {
                  margin-bottom: val(12);
                  line-height: val(32);
                  font-size: val(32);
                  color: #FFDEB4;
                }
                &:nth-of-type(2) {
                  margin-bottom: val(20);
                  line-height: val(16);
                  font-size: val(16);
                  color: #FFDEB4;
                }
                &:nth-of-type(3) {
                  overflow: auto;
                  height: val(32);
                  line-height: val(18);
                  font-size: val(14);
                  color: #FFFFFF;
                  opacity: 0.5;
                }
              }
            }
            &:nth-of-type(2) {
              p {
                &:first-of-type {
                  margin: val(36) 0 val(13);
                  line-height: val(16);
                  font-size: val(16);
                  color: #FFDEB4;
                  span {
                    &.molecular {
                      font-size: val(18);
                      color: #9B6A2F;
                    }
                    &.denominator {
                      font-size: val(14);
                    }
                  }
                }
              }
            }
            &:nth-of-type(3) {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              flex: 1;
              p {
                &:first-of-type {
                  cursor: pointer;
                  margin: val(20) 0 val(12);
                  width: val(100);
                  line-height: val(38);
                  text-align: center;
                  border: val(2) solid #FFFFFF;
                  border-radius: val(20);
                  font-size: val(16);
                  color: #FFFFFF;
                }
                &:nth-of-type(2) {
                  font-size: val(12);
                  line-height: val(14);
                  color: #FFFFFF;
                  opacity: 0.5;
                }
              }
            }
          }
        }
        &__nodata{
          position: absolute;
          width: val(286);
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          &__text {
            margin: val(30) auto 0;
            text-align: center;
            font-size: val(20);
            font-weight: 400;
            color: #727272;
          }
        }
      }
    }
  }
</style>